import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  initScene: {
    scene: 'registrationSignup',

    transform: payload => ({
      formDefaults: payload.form,
      recaptchaSiteKey: payload.recaptchaSiteKey,
      skipRecaptcha: payload.skipRecaptcha,
      urls: payload.urls,
      notice: payload.notice,
      oauthRegistration: payload.oauthRegistration,
      needBirthday: payload.needBirthday,
      formVisible: payload.formVisible || payload.type === 'email'
    })
  },

  path: () => ['scenes', 'registrationSignup', 'index'],

  actions: () => ({
    selectEmail: true,
    selectEmailOnly: true,
    unselectEmail: true,
    signupSuccess: true,
    setGrecaptchaObject: grecaptchaObject => ({ grecaptchaObject })
  }),

  reducers: ({ actions }) => ({
    formDefaults: [{}, PropTypes.object, {}],
    recaptchaSiteKey: [null, PropTypes.string, {}],
    skipRecaptcha: [false, PropTypes.bool, {}],
    urls: [{}, PropTypes.object, {}],
    notice: [null, PropTypes.string, {}],
    oauthRegistration: [false, PropTypes.bool, {}],
    needBirthday: [false, PropTypes.bool, {}],
    isEmailOnly: [
      false,
      PropTypes.bool,
      {
        [actions.selectEmailOnly]: () => true,
        [actions.selectEmail]: () => false,
        [actions.unselectEmail]: () => false
      }
    ],
    grecaptchaObject: [
      {},
      PropTypes.object,
      {
        [actions.setGrecaptchaObject]: (_, { grecaptchaObject }) => grecaptchaObject || {}
      }
    ],
    formVisible: [
      false,
      PropTypes.bool,
      {
        [actions.selectEmail]: () => true,
        [actions.selectEmailOnly]: () => true,
        [actions.unselectEmail]: () => false
      }
    ],

    redirecting: [
      false,
      PropTypes.bool,
      {
        [actions.signupSuccess]: () => true
      }
    ]
  }),

  actionToUrl: ({ actions }) => ({
    [actions.selectEmail]: () => '/signup/email',
    [actions.selectEmailOnly]: () => '/signup/emailonly',
    [actions.unselectEmail]: () => '/signup'
  }),

  urlToAction: ({ actions }) => ({
    '/signup/emailonly': () => actions.selectEmailOnly(),
    '/signup/email': () => actions.selectEmail(),
    '/signup': () => actions.unselectEmail()
  }),

  events: () => ({
    beforeMount: () => {
      if (typeof window !== 'undefined') {
        window.recaptchaOptions = {
          enterprise: true
        }
      }
    }
  })
})
